var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturningLeads(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.418 13.4937V32.9243C46.418 41.3747 41.3723 46.418 32.9243 46.418H13.4937C5.04563 46.418 0 41.3747 0 32.9243V13.4937C0 5.04331 5.04563 0 13.4937 0H32.9243C41.3723 0 46.418 5.04331 46.418 13.4937Z",
    fill: "url(#paint0_linear_3184_3040)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4316 19.5713C21.4316 18.7035 20.7282 18 19.8604 18C18.9926 18 18.2891 18.7035 18.2891 19.5713V32.7701C18.2891 33.6379 18.9926 34.3414 19.8604 34.3414C20.7282 34.3414 21.4316 33.6379 21.4316 32.7701V19.5713Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1426 22.0854C15.1426 21.2177 14.4391 20.5142 13.5713 20.5142C12.7035 20.5142 12 21.2177 12 22.0854V32.7702C12 33.638 12.7035 34.3415 13.5713 34.3415C14.4391 34.3415 15.1426 33.638 15.1426 32.7702V22.0854Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7129 14.5435C27.7129 13.6757 27.0094 12.9722 26.1416 12.9722C25.2738 12.9722 24.5703 13.6757 24.5703 14.5435V32.7704C24.5703 33.6382 25.2738 34.3417 26.1416 34.3417C27.0094 34.3417 27.7129 33.6382 27.7129 32.7704V14.5435Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.998 22.0854C33.998 21.2177 33.2946 20.5142 32.4268 20.5142C31.559 20.5142 30.8555 21.2177 30.8555 22.0854V32.7702C30.8555 33.638 31.559 34.3415 32.4268 34.3415C33.2946 34.3415 33.998 33.638 33.998 32.7702V22.0854Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3184_3040",
    x1: 10,
    y1: 51.5,
    x2: 46,
    y2: -8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00624724,
    stopColor: "#1964D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturningLeads);
export default __webpack_public_path__ + "static/media/ReturningLeads.7411bab8c7c1fab8cc64973694a17270.svg";
export { ForwardRef as ReactComponent };